import { Trophy } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { ComingSoon } from '../components/ui/ComingSoon';

export function TopPinsPage() {
  return (
    <>
      <PageHeader
        icon={Trophy}
        title="Top Pins"
        description="Best-performing pins for a keyword or interest, cached for speed."
      />
      <ComingSoon what="Top Pins UI" />
    </>
  );
}
